import { render, staticRenderFns } from "./ImportarProtocolosModal.vue?vue&type=template&id=6e75a4ee&scoped=true"
import script from "./ImportarProtocolosModal.vue?vue&type=script&lang=js"
export * from "./ImportarProtocolosModal.vue?vue&type=script&lang=js"
import style0 from "./ImportarProtocolosModal.vue?vue&type=style&index=0&id=6e75a4ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e75a4ee",
  null
  
)

export default component.exports